
export interface IngredientCategory {
  name: string;
  items: string[];
}

// Organize ingredients by category
export const INGREDIENT_CATEGORIES: IngredientCategory[] = [
  { 
    name: "Proteins", 
    items: ["chicken", "beef", "pork", "fish", "tofu", "eggs", "beans", "lentils", "chickpeas"]
  },
  { 
    name: "Dairy", 
    items: ["cheese", "milk", "yogurt", "butter", "cream"]
  },
  { 
    name: "Vegetables", 
    items: ["tomatoes", "spinach", "broccoli", "carrots", "onions", "bell peppers", "zucchini", "mushrooms", "lettuce", "cucumber", "potatoes", "corn", "peas"] 
  },
  { 
    name: "Fruits", 
    items: ["apple", "banana", "berries", "orange", "lemon", "lime", "avocado"] 
  },
  { 
    name: "Grains & Starches", 
    items: ["rice", "pasta", "bread", "flour", "oats", "quinoa"] 
  },
  { 
    name: "Others", 
    items: ["olive oil", "garlic", "herbs", "spices", "nuts", "soy sauce", "honey"] 
  }
];

// Get all predefined ingredients in a flat array
export const PREDEFINED_INGREDIENTS = INGREDIENT_CATEGORIES.flatMap(category => category.items);

export const LOCAL_STORAGE_KEY = "recipe-finder-saved-ingredients";
